import React from 'react';
import PropTypes from 'prop-types';
import { intersection } from 'lodash';
import TableHeading from './TableHeading';

const TableHeader = (props) => {
    function findColumnData(name, filter) {
        if (filter) {
            return props.children.find(element => element.name === filter);
        }
        return props.children.find(element => element.name === name);
    }

    const isSelected = !!props.rows.length &&
        intersection(props.rows, props.selectedRows).length === props.rows.length;

    return (
        <thead>
            <tr>{props.columns.map(colData =>
                <TableHeading
                    key={colData.columnName}
                    onSort={props.onSort}
                    onRowsSelect={props.onRowsSelect}
                    isSelected={isSelected}
                    {...findColumnData(colData.columnName, colData.filterBy)}
                    {...colData}
                />
            )}</tr>
        </thead>
    );
};

TableHeader.propTypes = {
    children: PropTypes.array,
    columns: PropTypes.array,
    rows: PropTypes.array,
    selectedRows: PropTypes.array,
    onSort: PropTypes.func,
    /**
     * On row select event handler
     */
    onRowsSelect: PropTypes.func
};

export default TableHeader;



// WEBPACK FOOTER //
// ./src/js/modules/DataTable/components/TableHeader.js